import { useState } from "react"

interface ProductListFilteringReturn {
  filterDrawerOpen: boolean
  setFilterDrawerOpen: (open: boolean) => void
}

export const useProductClassFiltering = (): ProductListFilteringReturn => {
  const [filterDrawerOpen, setFilterDrawerOpen] = useState<boolean>(false)

  return {
    filterDrawerOpen,
    setFilterDrawerOpen,
  }
}
